import React from 'react';

export default function FeatureSection({
  id,
  eyebrow,
  title,
  description,
  features,
  variant,
  visual,
}) {
  return (
    <section id={id} className={`featSec featSec--${variant || 'default'}`}>
      <div className="container featSec__inner">
        <div className="featSec__head reveal">
          <span className="eyebrow">{eyebrow}</span>
          <h2 className="featSec__title">{title}</h2>
          <p className="featSec__desc">{description}</p>
        </div>

        <div className={`featSec__layout ${visual ? 'featSec__layout--split' : ''}`}>
          <div className="featSec__grid">
            {features.map((f, i) => (
              <div
                key={f.title}
                className="featCard reveal"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div className="featCard__icon" style={{ background: f.bg, color: f.color }}>
                  {f.icon}
                </div>
                <div>
                  <h3 className="featCard__title">{f.title}</h3>
                  <p className="featCard__desc">{f.desc}</p>
                  {f.badge && <span className="featCard__badge">{f.badge}</span>}
                </div>
              </div>
            ))}
          </div>

          {visual && <div className="featSec__visual reveal">{visual}</div>}
        </div>
      </div>
    </section>
  );
}
